import $ from 'jquery';
import { loadFullSizeImage } from './helpers';
import { addElements } from './scroll';


const POLAROID_ENDPOINT = `${window.THEME_CONFIG.root}/wp-json/string-infusion/polaroid`;

const $polaroidImages = $('.polaroid__image');

const polaroidPromises = [];



if ($polaroidImages.length !== 0) {
	$.get(POLAROID_ENDPOINT)
		.then(function(res) {
			$polaroidImages.each(function(i) {
				const $this = $(this);
				$this.attr('data-src', res[i]);
				polaroidPromises.push(loadFullSizeImage({
					img: $this,
					classNames: ['polaroid__image'],
				}));
			});
		});


	addElements($polaroidImages[0]);
	$polaroidImages[0].addEventListener('inView', () => {
		Promise.all(polaroidPromises)
			.then(() => {
				$('.polaroid__image').each(function() {
					$(this).addClass('polaroid__image--show');
				});
			});
	});

	// Promise.all(polaroidPromises)
	// 	.then(() => {
	// 		$('.polaroid__image').each(function() {
	// 			$(this).addClass('polaroid__image--show');
	// 		});
	// 	});
}
